module.exports = __webpack_public_path__ + "static/media/rightsun.d175f6c1.png";